import React from "react";
import { Container, Row, Col, Card, Carousel, Button } from "react-bootstrap";
import { FaBalanceScale, FaGlobe, FaUsers, FaHandshake } from "react-icons/fa";
import MemberSearch from "../../../components/MemberSearch";
import Announcements from "../../../components/Announcement";
import { Helmet } from "react-helmet-async";
import "./HomePage.css";
import { useNavigate } from "react-router-dom";

export default function HomePage() {
  const navigate = useNavigate();
  return (
    <div>
      <Helmet>
        <title>Manav Adhikar Forum | MAF</title>
        <meta
          name="description"
          content="Learn about Human Rights, stay updated with announcements, and search for members. Promoting equality, dignity, and justice for all."
        />
        <meta
          name="keywords"
          content="Manav Adhikar Forum, human rights, dignity, equality, justice, MAF, awareness, announcements"
        />
        <meta name="author" content="MAF Human Rights Organization" />
        <link rel="canonical" href="https://manavadhikarforum.in/" />
      </Helmet>

      {/* 🌍 Top Carousel */}
      <Carousel controls={false}>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-img"
            src="/images/carousel1.jpg"
            alt="Justice for All"
            loading="lazy"
            height={500}
          />
          <Carousel.Caption>
            <h2>Chairman Benugopal Ghosh</h2>
            <p>
              Retd. Asst. Director, Central Int. Bureau M.H.A. Govt. of India
              (Ex-SSB, ARC, S.PG){" "}
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img
            className="d-block w-100 carousel-img"
            src="/images/carousel2.jpg"
            alt="Freedom & Rights"
            loading="lazy"
            height={500}
          />
          <Carousel.Caption>
            <h2>VVIP Duty with Rajiv Gandhi</h2>
            <p>1989, Delhi, India</p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img
            className="d-block w-100 carousel-img"
            src="/images/carousel3.jpg"
            alt="Freedom & Rights"
            loading="lazy"
            height={500}
          />
          <Carousel.Caption>
            <h2>Chairman Benugopal Ghosh</h2>
            <p>Kolkata, West Bengal, India</p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img
            className="d-block w-100 carousel-img"
            src="/images/carousel4.jpg"
            alt="Freedom & Rights"
            loading="lazy"
            height={500}
          />
          <Carousel.Caption>
            <h2>Chairman and Vice Presidents Meeting</h2>
            <p>Kolkata, West Bengal, India</p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>

      {/* 🔍 Search + Announcements */}
      <Container className="my-5">
        <Row>
          <Col md={6} sm={12} className="mb-4">
            <Card className="shadow-lg p-3 h-100 d-flex flex-column justify-content-between">
              <MemberSearch shadow={false} />
              <div className="mb-4 text-center px-4">
                <p className="text-muted">
                  Do you want to stand for{" "}
                  <span className="fw-semibold">justice and equality</span>?
                  Become a member of the{" "}
                  <span className="fw-semibold">Manav Adhikar Forum</span>{" "}
                  today.
                </p>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => navigate("/Membership")}
                  className="rounded-pill w-auto px-4"
                >
                  Join the Movement
                </Button>
              </div>
            </Card>
          </Col>
          <Col md={6} sm={12} className="mb-4">
            <Card
              className="shadow-lg p-3 pt-0 "
              style={{
                height: "460px",
                overflow: "auto",
                paddingBottom: "1rem",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              {/* <Card.Title>📢 Announcements</Card.Title> */}
              <Announcements />
            </Card>
          </Col>
        </Row>
      </Container>

      {/* 📖 Human Rights Info */}
      <Container className="my-5 text-center">
        <h2 className="fw-bold mb-4">What Are Human Rights?</h2>
        <Row>
          <Col md={3} sm={6} className="mb-4">
            <FaBalanceScale size={40} className="text-primary mb-3" />
            <h5>Universal</h5>
            <p>
              Rights that belong to everyone, everywhere, without
              discrimination.
            </p>
          </Col>
          <Col md={3} sm={6} className="mb-4">
            <FaGlobe size={40} className="text-success mb-3" />
            <h5>Inalienable</h5>
            <p>They cannot be taken away, except through due process of law.</p>
          </Col>
          <Col md={3} sm={6} className="mb-4">
            <FaUsers size={40} className="text-danger mb-3" />
            <h5>Equal</h5>
            <p>All people are equal in dignity, rights, and freedoms.</p>
          </Col>
          <Col md={3} sm={6} className="mb-4">
            <FaHandshake size={40} className="text-warning mb-3" />
            <h5>Obligations</h5>
            <p>Governments must respect, protect, and fulfill human rights.</p>
          </Col>
        </Row>
      </Container>

      {/* ✨ Call To Action */}
      <div
        className="hero-section"
        style={{ backgroundImage: `url('/images/bottomsection.jpg')` }}
      >
        <div className="content">
          <h4 className="fw-bold">
            The Universal Declaration of Human Rights stands as a promise of
            dignity, freedom, and justice for all.
          </h4>
          <p>
            While challenges of culture and implementation remain, it calls on
            us to carry forward the fight to protect and uphold these rights
            everywhere.
          </p>
        </div>
      </div>
    </div>
  );
}
